import { render, staticRenderFns } from "./ModalDocumentosAdicionarVariosRegistroEntrada.vue?vue&type=template&id=e4b5bade"
import script from "./ModalDocumentosAdicionarVariosRegistroEntrada.vue?vue&type=script&lang=js"
export * from "./ModalDocumentosAdicionarVariosRegistroEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports